/* cali 2026-10-14 press: filters and "View more" for the image grids, copy buttons, original-file downloads. Every visible word comes from the section's settings (data attributes), so it is translated with the page. */
(() => {
  const fill = (template, values) =>
    Object.keys(values).reduce((text, key) => text.split(`[${key}]`).join(String(values[key])), template || '');

  const setupGallery = (root, gallery) => {
    const cards = [...gallery.querySelectorAll('.cp-card')];
    if (!cards.length) return;
    const filters = [...gallery.querySelectorAll('[data-filter]')];
    const filterGroup = gallery.querySelector('[data-cp-filters]');
    const more = gallery.querySelector('[data-cp-more]');
    const status = gallery.querySelector('[data-cp-status]');
    const batch = Number(gallery.dataset.batch) || 12;
    const moreLabel = gallery.dataset.more || (more ? more.textContent.trim() : '');
    let active = 'all';
    let limit = batch;

    const matching = () => cards.filter((card) => active === 'all' || card.dataset.category === active);
    const render = () => {
      const matches = matching();
      const shown = new Set(matches.slice(0, limit));
      cards.forEach((card) => { card.hidden = !shown.has(card); });
      const remaining = matches.length - shown.size;
      if (more) {
        more.hidden = remaining <= 0;
        more.textContent = `${moreLabel} (${remaining})`;
      }
      if (status) {
        status.textContent = remaining > 0 ? fill(root.dataset.showing, { shown: shown.size, total: matches.length }) : '';
      }
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        active = button.dataset.filter;
        limit = batch;
        filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        render();
      });
    });
    if (more) {
      more.addEventListener('click', () => {
        const first = matching()[limit];
        limit += batch;
        render();
        const link = first && first.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      });
    }
    // Filters only help when there is more than one category to choose from.
    if (filterGroup && filters.length > 2) filterGroup.hidden = false;
    render();
  };

  const setupCopy = (root) => {
    const status = root.querySelector('[data-cp-copy-status]');
    const fallback = root.querySelector('[data-cp-copy-fallback]');
    root.querySelectorAll('[data-cp-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const text = button.dataset.cpCopy === 'short'
          ? (root.querySelector('[data-cp-short]')?.innerText || '').trim()
          : [...root.querySelectorAll('[data-cp-story] p')].map((p) => p.innerText.trim()).join('\n\n');
        if (fallback) fallback.hidden = true;
        try {
          await navigator.clipboard.writeText(text);
          if (status) status.textContent = root.dataset.copied || '';
        } catch (_) {
          if (fallback) {
            fallback.value = text;
            fallback.hidden = false;
            fallback.focus();
            fallback.select();
          }
          if (status) status.textContent = root.dataset.copyFailed || '';
        }
        window.setTimeout(() => { if (status) status.textContent = ''; }, 2600);
      });
    });
  };

  // Browsers ignore <a download> across origins, so the file is fetched and saved as a blob.
  // When that fails (CORS, network), the link opens the original in a new tab instead.
  const setupDownloads = (root) => {
    root.addEventListener('click', async (event) => {
      const link = event.target.closest('[data-cp-download]');
      if (!link || link.dataset.fallback === 'true') return;
      event.preventDefault();
      const label = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = root.dataset.preparing || label;
      try {
        const response = await fetch(link.href, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error(String(response.status));
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const save = document.createElement('a');
        save.href = url;
        save.download = link.getAttribute('download') || '';
        document.body.append(save);
        save.click();
        save.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 30000);
        link.textContent = label;
      } catch (_) {
        link.dataset.fallback = 'true';
        link.removeAttribute('download');
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = root.dataset.openOriginal || label;
      } finally {
        link.removeAttribute('aria-busy');
      }
    });
  };

  const initialize = (root) => {
    if (!root || root.dataset.cpReady === 'true') return;
    root.dataset.cpReady = 'true';
    root.querySelectorAll('[data-cp-gallery]').forEach((gallery) => setupGallery(root, gallery));
    setupCopy(root);
    setupDownloads(root);
  };

  document.querySelectorAll('[data-cali-press]').forEach(initialize);
  // The theme editor replaces a section's markup when one of its settings changes.
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-cali-press]');
    if (root) initialize(root);
  });
})();
